import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { dateTimeState } from 'libs/atoms';
import { convertZeroNumber } from 'libs/utils';
import { MEDIA_SIZE_LIST } from 'libs/const';

const SDelay = styled.span<{ isWarn: boolean; isWhite: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ isWarn, isWhite, theme: { skyw } }) => {
    if (isWarn) return skyw.warnColor;

    return isWhite ? '#ffffff' : skyw.mainColor1;
  }};
  font-size: 13px;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[0]}px`}) {
    font-size: 11px;
  }
`;

interface DelayProps {
  obsId: number;
  date?: string;
  time?: string;
  warnTime?: number;
  isWhite?: boolean;
}

const Delay = ({ obsId, date, time, warnTime, isWhite = false }: DelayProps) => {
  const cntDateTime = useRecoilValue(dateTimeState);
  const delay = useMemo(() => {
    if (!cntDateTime || !date || !time || obsId !== cntDateTime.obsId)
      return {
        time: '00:00:00',
        warn: false,
      };

    const skycamDate = new Date(`${date.replaceAll('-', '/')} ${time}`);
    const cntDate = new Date(`${cntDateTime.date.replaceAll('-', '/')} ${cntDateTime.time}`);
    const diff = (cntDate.getTime() - skycamDate.getTime()) / 1000; // 초단위;

    if (diff <= 0) {
      return {
        time: '00:00:00',
        warn: false,
      };
    }

    const seconds = diff % 60;
    const minutes = ((diff - seconds) / 60) % 60;
    const hours = (diff - minutes * 60 - seconds) / (60 * 60);

    return {
      time: `${convertZeroNumber(hours)}:${convertZeroNumber(minutes)}:${convertZeroNumber(seconds)}`,
      warn: warnTime === undefined ? false : diff > warnTime,
    };
  }, [date, time, cntDateTime, obsId, warnTime]);

  return (
    <SDelay isWarn={delay.warn} isWhite={isWhite}>
      + {delay.time}
    </SDelay>
  );
};

export default Delay;
